// @flow
import React from 'react';
import classnames from 'classnames';

import { FooterAnnexes } from './footer-annexes/FooterAnnexes.jsx';
import { FooterContacts } from './footer-contacts/FooterContacts.jsx';
import { FooterPolicies, type FooterPoliciesProps } from './footer-policies/FooterPolicies.jsx';
import { FooterSeo } from './footer-seo/FooterSeo.jsx';
import { FooterSocialNetworks } from './footer-social-networks/FooterSocialNetworks.jsx';
import { FooterTripAdvisor } from './footer-tripadvisor/FooterTripAdvisor.jsx';
import { FooterWebsites } from './footer-websites/FooterWebsites.jsx';

type Props = {
  annexes: CMSFooterAnnexes,
  className?: string,
  contacts: CMSFooterContacts,
  policies: FooterPoliciesProps,
  seo: $PropertyType<CMSFooter, 'seo'>,
  socialNetworks: CMSFooterSocialNetworks,
  tabText: string,
  tripAdvisor: $PropertyType<CMSFooter, 'tripAdvisor'>,
  websites: CMSFooterWebsites,
};

export function Footer(props: Props) {
  const {
    annexes,
    contacts,
    className,
    policies,
    socialNetworks,
    seo,
    tabText,
    tripAdvisor,
    websites,
  } = props;

  return (
    <div className={classnames(className, 'relative z-3')} data-testid="Footer">
      <div className="text-md text-white">
        <div className="m-auto w-full max-w-site">
          <div
            className="bg-gray-darker font-bold inline-block px-2 relative text-md text-gray-darker"
            style={{
              bottom: '-1px',
              height: '2.5rem',
              left: '1.5rem',
              lineHeight: '2.5rem',
              right: '1.5rem',
            }}
          >
            <svg
              className="absolute fill-current top-0"
              width="24"
              height="40"
              viewBox="0 0 24 40"
              style={{
                height: '2.5rem',
                left: -23,
              }}
            >
              <path d="M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z" />
            </svg>
            <svg
              className="absolute fill-current top-0 -scale-x-1"
              width="24"
              height="40"
              viewBox="0 0 24 40"
              style={{
                height: '2.5rem',
                right: -23,
              }}
            >
              <path d="M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z" />
            </svg>
            <span className="text-white">{tabText}</span>
          </div>
        </div>
        <div className="bg-gray-darker flex items-center px-5">
          <div className="flex flex-col lg:flex-row md:items-end m-auto max-w-site relative w-full">
            <FooterContacts items={contacts} />
            <FooterSocialNetworks items={socialNetworks} />
          </div>
        </div>
      </div>
      <footer className="bg-gray-darker text-white">
        <div className="flex flex-wrap m-auto max-w-site px-5 lg:px-0 py-5">
          <FooterWebsites {...websites} className="hidden sm:block lg:w-2/5 lg:rtl:pr-24" />
          <div className="lg:w-3/5">
            <FooterAnnexes items={annexes} className="hidden sm:block" />
            <FooterSeo {...seo} className="md:w-4/5 lg:w-auto" />
            <FooterPolicies items={policies} className="mt-8" />
          </div>
          <FooterTripAdvisor {...tripAdvisor} className="mt-5 pt-5 w-full" />
        </div>
      </footer>
    </div>
  );
}
